import React, { Component } from "react";
import { Formik, Field, Form} from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";



class MainFooter extends Component {

    constructor() {
        super();
        this.subscribeNewsletter = this.subscribeNewsletter.bind(this);
      }
    
    componentDidMount() {}

    validationSchemaNews = Yup.object().shape({
    email: Yup.string().email().required("Não pode submeter um email vazio")
    });

    subscribeNewsletter(email){
    return this.api.post(`/results_page`, email)
        .then(res => {
            console.log(res);
            const confirmation_comment = document.getElementById("submit_news_conf");
            const error_comment = document.getElementById("submit_news_error");
            if(res.status == 201){
                error_comment.classList.add("d-none")
                confirmation_comment.classList.remove("d-none");  
            }else{
                confirmation_comment.classList.add("d-none");
                error_comment.classList.remove("d-none");
            }
        })
        .catch(err => {
            console.log(err);
        })
    }; 

    onChangeCaptcha(value) {
        console.log("Captcha value:", value);
        }

    render() {

        const environment_url = window.location.origin;

        return (
                <footer>
                    <div class="footer-top">
                        <div class="footer-top2">
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-12">
                                        <div class="footer-widget">
                                            <div class="footer-title">
                                                <h2>LARES ONLINE</h2>
                                            </div>
                                            <div class="footer-content">
                                                <p>O Lares Online é uma plataforma de impacto social no âmbito das respostas sociais para a terceira idade, que liga as famílias às instituições, desde 2011.</p>
                                            </div>
                                        </div>
                                        <div class="footer-widget d-flex justify-content-between">
                                            <div class="footer-content-left">
                                                <div class="footer-title">
                                                    <h2>CONTACTOS</h2>
                                                </div>
                                                <div class="footer-content">
                                                    <p class="contacts">Exclusivo a admissão de idosos:</p>
                                                    <span>
                                                        <img src="img/about/phone-fontawesome.svg" alt="icon-telefone" />
                                                        <a href="tel:(+351)939667800">(+351) 939 667 800</a>
                                                    </span>
                                                    <span>
                                                        <img src="img/about/envelope-fontawesome.svg" alt="icon-email" />
                                                        <a href="mailto:geral@laresonline.pt">geral@laresonline.pt</a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="footer-content-right">
                                                <div class="footer-title">
                                                    <h2>SIGA-NOS</h2>
                                                </div>
                                                <div class="footer-content-nos position-relative">
                                                    <ul>
                                                        <li>
                                                            <a title="Facebook" href="https://www.facebook.com/LaresOnline/" target="_blank" rel="noopener noreferrer" class="fa fa-facebook">{" "}</a>
                                                        </li>
                                                        <li>
                                                            <a title="Linkedin" href="https://www.linkedin.com/company/lares-online" target="_blank" rel="noopener noreferrer" class="fa fa-linkedin">{" "}</a>
                                                        </li>
                                                        <li>
                                                            <a title="Youtube" href="https://www.youtube.com/channel/UC8HNfjhGOmg2qWJew0I_Cug" target="_blank" rel="noopener noreferrer" class="fa fa-youtube">{" "}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="footer-logo">
                                            <a href={environment_url}><img src="img/logo/footer-logo.svg" alt="Logotipo LaresOnline" /></a>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-12">
                                        <div class="footer-widget">
                                            <div class="footer-title">
                                                <h2>LINKS ÚTEIS</h2>
                                            </div>
                                            <div class="footer-menu">
                                                <ul>
                                                    <li><a href={environment_url+"/pt/sobre-nos/"} alt="Sobre nós">Sobre Nós</a></li> 
                                                    <li><a href={environment_url+"/pt/blog/pag/1/"}>Blog</a></li>
                                                    <li><a href={environment_url+"/pt/perguntas-frequentes/familias"} alt="Perguntas frequentes">Perguntas Frequentes</a></li>
                                                    <li><a href={environment_url+"/pt/sobre-nos/#testimonials"} alt="Testemunhos">Testemunhos</a></li>
                                                    <li><a href={environment_url+"/pt/licencas-e-atos/pag/1/"} alt="Check Licenças e Atos">Check Licenças e Atos</a></li>
                                                    <li><a href={environment_url+"/pt/registar-gratis/"} alt="Torne-se Membro">Torne-se Membro</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-12">
                                        <div class="footer-widget">
                                            <div class="footer-title">
                                                <h2>SUBSCREVA A NOSSA NEWSLETTER</h2>
                                            </div>
                                            <div class="footer-contact-form">
                                                <Formik
                                                    initialValues={{ email: "" }}
                                                    validationSchema={this.validationSchemaNews}
                                                    validateOnChange={true}
                                                    validateOnBlur={true}   
                                                    onSubmit={(values) => {
                                                        setTimeout(() => {
                                                            JSON.stringify(values, null, 2);
                                                            this.subscribeNewsletter(values);
                                                        }, 400);
                                                    }}
                                                >
                                                {({
                                                    values,
                                                    handleSubmit,
                                                    isSubmitting
                                                }) => (
                                                    <Form id="newsletter-form" onSubmit={handleSubmit}>
                                                    <Field 
                                                        id="placeholder-email"
                                                        name="email" 
                                                        type="email" 
                                                        placeholder="Inserir email"
                                                        value={values.email}
                                                    />
                                                    {values.email && (
                                                    <p class="captcha">
                                                    <ReCAPTCHA
                                                        sitekey="6LfCTgcUAAAAAArYl9T8Fw7DIBLmtJSEsOnI53tD"
                                                        onChange={this.onChangeCaptcha}
                                                        class="mb-3 recaptcha"
                                                    />
                                                    </p>
                                                    )}
                                                    <button type="submit">Subscrever</button>
                                                    <p id="submit_news_conf" class="text-center mb-4 d-none">Email submetido com sucesso</p>
                                                    <p id="submit_news_error" class="text-center mb-4 d-none">Ocorreu um erro ao gravar. <br/> Por favor verifique se o email não existe já na nossa lista.</p>
                                                    <p class="submit-label">Para receber conselhos, promocões e novidades no seu email.
                                                        Ao subscrever, aceita a nossa <a href={environment_url+"/pt/politica-de-privacidade/"} alt="politica de privacidade e cookies">politica de privacidade e cookies.</a></p>
                                                    </Form>)}
                                                </Formik>

                                                {/* TRADUÇOES SITE */}
                                                {/* <div class="language-options">
                                                    <select name="#" id="">
                                                        <option value="1">PT</option>
                                                        <option value="2">EN</option>
                                                        <option value="3">FR</option>
                                                    </select>
                                                    <span class="global"><img src="img/globe-americas-solid.svg" alt="" /></span>
                                                    <span class="arrow-dwosn"><img src="img/sort-down.svg" alt="" /></span>
                                                </div> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer-bottom">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="footer-copyright d-flex justify-content-between">
                                        <span class="footer-copyright1">© Copyright 2021 Lares Online - Todos os direitos reservados</span>
                                        <span>
                                            <a class="pr-3 footer-copyright2" href={environment_url+"/pt/mapa-do-site/"} alt="Mapa do site">Mapa do site</a>
                                            <a class="pr-3 footer-copyright3" href={environment_url+"/pt/politica-de-privacidade/"} alt="Politicas de privacidade e Cookies">Politicas de Privacidade e Cookies</a>
                                            <a class="footer-copyright4" href={environment_url+"/pt/termos-condicoes/"} alt="Termos e Condições">Termos e Condições</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer> 
            )}}

export default MainFooter;
